import React, { Component } from 'react';

function logResult(result) {
  console.log('I love this result .... \n\n\n', result);
}


function validateResponse(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


function readResponseAsJSON(response) {
  return response.json();
}

class Employees extends Component {

  constructor(props) {
    super(props);
    this.state = ({employees: []});
    console.log("employees are loading!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    //return {employees: []};
  }



  loadEmployeesFromServer() {
    var self = this;
    fetch('https://localhost/developer/mvc/employees/list')
        .then(results=> {
            validateResponse(results);
            logResult(results);
            return readResponseAsJSON(results);
            //return results.json();
        })
        .catch(error => {
            console.log('You better believe there was an error:\n', error);
            return Promise.reject()
        })
        .then(data => {
            self.setState({employees: data});
        });
  }

  handleReset(){
    fetch('https://localhost/developer/mvc/employees/reset');
    this.loadEmployeesFromServer();
    // self.setState()

 //     location.reload();
  }

  componentDidMount() {
    this.loadEmployeesFromServer();
  }

  render() {
    return [ <EmployeeTable employees={this.state.employees}/>,
             <button name="Reset" onClick={() => this.handleReset()}>Reset</button>
           ];
  }
}



class EmployeeTable extends React.Component {

  render() {
    var rows = [];
    this.props.employees.forEach(function(employee) {
      rows.push(<Employee employee={employee} />);
    });
    return (
    <div className="container">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th><th>First</th><th>Last</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>

    );
  }
}


class Employee extends React.Component {

  constructor(props) {
    super(props);
    this.state = ({display:true});
  }

  handleDelete() {
    fetch("https://localhost/developer/mvc/employees/delete/"+this.props.employee.lastName, {
        method: 'GET'
    })
        .then(results=> {
            validateResponse(results);
            logResult(results);
            return readResponseAsJSON(results);
            //return results.json();
        })
        .catch(error => {
            console.log('There was an error deleting:\n', error);
            //toastr.error(error.message);
            alert("Uh oh.... didn't work " + error.message);
            return Promise.reject();
        })
        .then(data => {
            this.setState({display: false});
        });

  }

  render() {
    if (this.state.display===false) return null;
    else return (
      <tr>
        <td>{this.props.employee.id}</td>
        <td>{this.props.employee.firstName}</td>
        <td>{this.props.employee.lastName}</td>
        <td><button className="btn btn-info" onClick={() => this.handleDelete()}>Delete me</button></td>
      </tr>);
  }
}

export default Employees;



// WEBPACK FOOTER //
// ./src/Employees.js